module.exports = __webpack_public_path__ + "assets/copy-solid.0a0c051f.svg";